/**
 * 登录回跳地址净化（防开放重定向）。
 *
 * 规则：只接受「站内已知路由」的绝对路径，并且可以带查询串。
 * 明确拒绝：
 *   - 非 `/` 开头（`https://evil.example`、`javascript:...`）；
 *   - `//host`（协议相对地址，浏览器会跳到外站）；
 *   - 含反斜杠（部分浏览器把 `\` 当 `/`，`/\evil.com` 会变成外站）；
 *   - 不在白名单里的路径（`/login`、`/nope`）。
 * 拒绝时回落到 `/`，而不是抛错或原样使用。
 */

/**
 * 站内已知路由白名单（**必须与 `router.tsx` 的 path 列表保持同步**）。
 *
 * ⚠️ 2026-10-04 修正：此前只有 `/,/overview,/settings` 三条，导致从 `/products`、
 * `/ad-management`、`/style-codes` 等页面被踢到登录页后，登录成功会被**静默送回首页**
 * （`safeRedirect` 拒绝未知路径就回落 `/`），用户以为「点进去就跳走了」。
 * 新增路由时请同步这里，并跑 `redirect.spec.ts`（它逐条断言白名单与路由一致）。
 */
const KNOWN_REDIRECT_PATHS: ReadonlySet<string> = new Set([
  "/",
  "/overview",
  // 2026-10-05 第十九批：花费总览（新路由，登录回跳白名单必须同步）。
  "/spend-overview",
  "/sync",
  "/settings",
  "/products",
  "/products/categories",
  "/style-codes",
  // 2026-10-06（task-23 · C2）：素材看板（新路由，登录回跳白名单必须同步）。
  "/creatives",
  "/ad-management",
  // 2026-10-05 第二十批：Google 系列（新路由，登录回跳白名单必须同步）。
  "/google-campaigns",
]);

export function safeRedirect(raw: string): string {
  if (!raw.startsWith("/")) return "/";
  if (raw.startsWith("//")) return "/";
  if (raw.includes("\\")) return "/";
  const path = raw.split("?")[0] ?? "";
  return KNOWN_REDIRECT_PATHS.has(path) ? raw : "/";
}
